function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'sortImg',
  props: {
    imgUrlList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    changeList: {
      type: Function,
      required: true,
      default: function _default() {}
    }
  },
  watch: {
    imgUrlList: {
      handler: function handler(newVal) {
        this.imgs = _toConsumableArray(newVal);
      }
    }
  },
  data: function data() {
    return {
      imgs: [],
      draggedIndex: null
    };
  },
  methods: {
    handleDragStart: function handleDragStart(e, index) {
      // 获取被拖拽图片的索引
      this.draggedIndex = index;
    },
    handleDragOver: function handleDragOver(e, url) {
      e.preventDefault();
    },
    handleDragEnter: function handleDragEnter(e, index) {
      var imgList = _toConsumableArray(this.imgs);
      // 获取当前拖拽的图片索引
      var currentIndex = index;
      // 获取被拖拽图片的索引
      var draggedIndex = this.draggedIndex;
      // 如果当前拖拽的图片不等于被拖拽图片，说明需要交换位置
      if (currentIndex !== draggedIndex) {
        // 交换位置
        var temp = imgList[currentIndex];
        imgList[currentIndex] = imgList[draggedIndex];
        imgList[draggedIndex] = temp;
        // 更新被拖拽图片的索引
        this.draggedIndex = currentIndex;
      }
      this.imgs = imgList;
      this.changeList(this.imgs);
    },
    handleDragEnd: function handleDragEnd(e, url) {
      this.draggedIndex = null;
    },
    handleRemove: function handleRemove(index) {
      this.imgs.splice(index, 1);
      this.changeList(this.imgs);
    }
  }
};